import {
	type ClientPortfolioInvestmentFrequencyEnum,
	ClientPortfolioInvestmentTypeEnum,
	type CurrencyEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";
import { DEFAULT_INSTRUCTION_CURRENCY } from "web_myplann/Portfolio/Forms/ToolsShared/constants";
import type {
	InstructionInput,
	InstructionOutput,
} from "web_myplann/Portfolio/Forms/ToolsShared/instructionSchema";

type InstructionResponse = {
	id: number;
	investmentType?: ClientPortfolioInvestmentTypeEnum | null;
	startAt?: string | null;
	endAt?: string | null;
	amount?: number | null;
	currency?: CurrencyEnum | null;
	frequency: ClientPortfolioInvestmentFrequencyEnum;
};

export const mapInstructionToRequest = (instruction: InstructionOutput) => ({
	id: instruction.id,
	investmentType: instruction.investmentType,
	startAt: instruction.date,
	endAt: instruction.endedAt,
	amount: instruction.amount,
	currency: instruction.currency,
	frequency: instruction.frequency,
});

export const mapInstructionToForm = <T extends InstructionResponse>(
	instruction: T,
): InstructionInput => ({
	id: instruction.id,
	investmentType:
		instruction.investmentType ?? ClientPortfolioInvestmentTypeEnum.Buy,
	date: parseIsoDate(instruction.startAt),
	endedAt: parseIsoDate(instruction.endAt),
	amount: instruction.amount ?? null,
	currency: instruction.currency ?? DEFAULT_INSTRUCTION_CURRENCY,
	frequency: instruction.frequency,
});
